import { render } from "./vgpDatePicker.vue?vue&type=template&id=0c5c839c&scoped=true"
import script from "./vgpDatePicker.vue?vue&type=script&lang=js"
export * from "./vgpDatePicker.vue?vue&type=script&lang=js"

import "./datePicker.less?vue&type=style&index=0&lang=less&external"
import "./vgpDatePicker.vue?vue&type=style&index=1&id=0c5c839c&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5c839c"]])

export default __exports__